<mat-horizontal-stepper [linear]="true" #stepper>
    <mat-step>
        <div class="temp-content">
            <ng-template matStepLabel>Fill out your role</ng-template>
            <mat-label>Fill Out Your Role</mat-label>
            <br>
            <mat-radio-group
              aria-labelledby="example-radio-group-label"
              class="example-radio-group"
              [(ngModel)]="user.role" name="fieldName" ngDefaultControl>
              <mat-radio-button class="example-radio-button" *ngFor="let role of roles" [value]="role">
                <span>I am a {{role}}</span>  
              </mat-radio-button>
              </mat-radio-group>
          <div>
            <button mat-button matStepperNext [disabled]="user.role == ''" class="setButton">Continue</button>
          </div>
        </div>
    </mat-step>
    <mat-step label="Log Into Account">
    <div class="temp-content temp-content2">
          <mat-label>Email</mat-label>
          <br>
          <mat-form-field>
            <input matInput type="email" placeholder="Enter Email"
            required [(ngModel)]="user.email">
          </mat-form-field>
          <br>
        <mat-label>Password</mat-label>
        <br>
        <mat-form-field>
            <input matInput type="password" placeholder="Enter Password"
            required [(ngModel)]="user.password">
        </mat-form-field>
        
        <div>
          <button mat-button matStepperPrevious class="setButton gray">Back</button>
          <button mat-button matStepperNext class="setButton" [disabled]="user.email == '' || user.password == ''" (click)="logIn(user)">Login</button>
        </div>
    </div>
    </mat-step>
    <mat-step>
    <div class="temp-content">
    <ng-template matStepLabel>Done</ng-template>
    <mat-label>Logged In!</mat-label>
      <p class="description">You are now done.</p>
      <div>
        <button mat-button class="setButton" [routerLink]="['/profile']">View Profile</button>
      </div>
    </div>
    </mat-step>
</mat-horizontal-stepper>
  
<p class="more">Don't have an account? Sign up <a routerLink='/signup'>here</a></p>